import { Link } from "react-router-dom";
import "./MenuFeature.scss";

function MenuFeature({
  link,
  img,
  imgAlt,
  heading,
  text,
}: {
  link: string;
  img: string;
  imgAlt: string;
  heading: string;
  text: string;
}) {
  return (
    <Link to={link} className="menu-banner" aria-label={heading}>
      <img src={img} alt={imgAlt} className="menu-banner__img" />
      <div className="menu-banner__side">
        <div className="menu-banner__text">
          <h2 className="menu-heading">{heading}</h2>
          <hr className="divider--decorative" />
          <p>{text}</p>
        </div>
      </div>
    </Link>
  );
}

export default MenuFeature;
